import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import FlaggingCategorySession from './FlaggingCategorySession';
import FlaggingStatusSession from './FLaggingStatusSession';
import {
    flagSessionCategory,
    submitFlagSession,
} from '../../action/educator/FlagSessionModuleAction';
import { showNotification } from '../../action/NotificationAction';
import { RESPONSE_CONSTANT } from '../../../utils/ResponseConstant';
import { flagStatusListing } from '../../action/Admin/CommonAction';

class FlaggedSessionTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            seletedFlagDetails: {},
            openFlagInfo: false,
            flagReason: '',
            flagCategoryId: '',
            otherCategory: '',
            flagCategoryList: [],
            isFlagCategoryLoading: false,
            flagBtnLoading: false,
            flagStatusList: '',
            flagStatusId: '',
            flagStatusSummary: '',
            moreInfoReason: '',
        };
    }

    // componentDidMount
    componentDidMount() {
        if (this.props.isFromEducator) {
            this.getFlagCategoryList();
        } else {
            this.getFlagStatusList();
        }
    }

    // getFlagCategoryList
    getFlagCategoryList() {
        this.setState({ isFlagCategoryLoading: true });
        this.props.flagSessionCategory((response) => {
            this.setState({ isFlagCategoryLoading: false });
            if (response) {
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    this.setState({ flagCategoryList: response.response });
                } else {
                    this.props.showNotification(response.message, RESPONSE_CONSTANT.ERROR);
                    this.setState({ flagCategoryList: [] });
                }
            }
        });
    }

    // getFlagStatusList
    getFlagStatusList() {
        this.setState({ isFlagCategoryLoading: true });
        this.props.flagStatusListing(this.props.sessionId, (response) => {
            this.setState({ isFlagCategoryLoading: false });
            if (response) {
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    let flagStatus = [];
                    if (response.response) {
                        response.response.forEach((element) => {
                            let object = {
                                label: element.status,
                                name: element.statusId,
                            };
                            flagStatus.push(object);
                        });
                    }
                    this.setState({ flagStatusList: flagStatus });
                } else {
                    this.props.showNotification(response.message, RESPONSE_CONSTANT.ERROR);
                    this.setState({ flagStatusList: [] });
                }
            }
        });
    }

    // renderStatus
    renderStatus(data, index, messageLength) {
        const status = data.status.status.toLowerCase();
        switch (status) {
            case 'under review':
                return (
                    <span
                        className={`inline-flex items-center rounded-md ${
                            status === 'under review'
                                ? `bg-warning/10 px-2 py-1 text-xs font-medium ring-inset ring-warning/10 text-warning capitalize${
                                      !this.props.isFromEducator && index === messageLength - 1
                                          ? ' cursor-pointer'
                                          : ''
                                  }`
                                : ''
                        }`}
                        onClick={() => {
                            if (!this.props.isFromEducator && index === messageLength - 1) {
                                this.openCancelModal(data, false);
                            }
                        }}
                    >
                        {status}
                        {!this.props.isFromEducator && index === messageLength - 1 && (
                            <i className="pl-3 fal fa-edit text-primary" aria-hidden="true"></i>
                        )}
                    </span>
                );
            case 'more info needed':
                return (
                    <span
                        className={`inline-flex items-center rounded-md ${
                            status === 'more info needed'
                                ? `bg-gray/10 px-2 py-1 text-xs font-medium ring-inset ring-gray/10 text-gray capitalize${
                                      this.props.isFromEducator && index === messageLength - 1
                                          ? ' cursor-pointer'
                                          : ''
                                  }`
                                : ''
                        }`}
                        onClick={() => {
                            if (this.props.isFromEducator && index === messageLength - 1) {
                                this.openCancelModal(data, true);
                            }
                        }}
                    >
                        {status}
                        {this.props.isFromEducator && index === messageLength - 1 && (
                            <i className="pl-3 fal fa-edit text-primary" aria-hidden="true"></i>
                        )}
                    </span>
                );
            case 'action taken':
                return (
                    <span className="inline-flex items-center px-2 py-1 text-xs font-medium capitalize rounded-md bg-success/10 ring-inset ring-success/10 text-success">
                        {status}
                    </span>
                );
            default:
                return null;
        }
    }

    // openCancelModal
    openCancelModal = (data, isMoreInfoNeeded) => {
        this.setState({
            flagStatusSummary: '',
            seletedFlagDetails: data,
            flagReason: data.message,
            flagCategoryId: this.props.isFromEducator
                ? this.state.flagCategoryList.find((e) => e.id === data.id)
                : '',
            flagStatusId: this.props.isFromEducator
                ? ''
                : this.state.flagStatusList.find((e) => e.name === data.status.statusId),
            otherCategory: '',
            openFlagInfo: true,
            isMoreInfoNeeded: isMoreInfoNeeded,
            moreInfoReason: '',
        });
    };

    // onChangeFlagSession
    onChangeFlagSession = (event, name) => {
        this.setState({
            [name]:
                name === 'flagCategoryId' || name === 'flagStatusId' ? event : event.target.value,
        });
    };

    //flagSubmitBtn
    flagSubmitBtn = () => {
        const { flagReason, flagCategoryId, isMoreInfoNeeded, moreInfoReason } = this.state;
        let values = {};
        if (isMoreInfoNeeded) {
            values = {
                sessionId: this.props.sessionId,
                reason: moreInfoReason,
                status: '',
            };
        } else {
            values = {
                sessionId: this.props.sessionId,
                categoryId: flagCategoryId?.id,
                reason: flagReason,
                status: '',
            };
            if (!values.categoryId) {
                this.props.showNotification(
                    RESPONSE_CONSTANT.CATEGORY_MANDATORY,
                    RESPONSE_CONSTANT.WARNING
                );
                return;
            }
        }
        if (!values.reason) {
            this.props.showNotification(
                RESPONSE_CONSTANT.CANCELATION_REASON_EMPTY,
                RESPONSE_CONSTANT.WARNING
            );
            return;
        }
        this.setState({ flagBtnLoading: true });
        this.props.submitFlagSession(values, (response) => {
            if (this.props.isFromEducator) {
                this.props.invokeVisitInfo(this.props.sessionId, true);
            }
            this.setState({ flagBtnLoading: false, openFlagInfo: false });
            if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.props.showNotification(response.message, RESPONSE_CONSTANT.SUCCESS);
            } else {
                if (response.message) {
                    this.props.showNotification(response.message, RESPONSE_CONSTANT.ERROR);
                }
            }
        });
    };

    // flagStatusBtn
    flagStatusBtn = () => {
        const { flagStatusSummary, flagStatusId } = this.state;
        const values = {
            sessionId: this.props.sessionId,
            reason: flagStatusSummary,
            status: flagStatusId?.label,
        };
        if (!values.status) {
            this.props.showNotification(
                RESPONSE_CONSTANT.FLAGGING_STATUS,
                RESPONSE_CONSTANT.WARNING
            );
            return;
        }
        if (!values.reason) {
            this.props.showNotification(
                RESPONSE_CONSTANT.CANCELATION_REASON_EMPTY,
                RESPONSE_CONSTANT.WARNING
            );
            return;
        }
        this.setState({ flagBtnLoading: true });
        this.props.submitFlagSession(values, (response) => {
            this.props.invokeVisitInfo(this.props.sessionId);
            this.setState({ flagBtnLoading: false, openFlagInfo: false });
            if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.props.showNotification(response.message, RESPONSE_CONSTANT.SUCCESS);
            } else {
                if (response.message) {
                    this.props.showNotification(response.message, RESPONSE_CONSTANT.ERROR);
                }
            }
        });
    };

    render() {
        return (
            <>
                <div className="p-3 font-medium text-end">
                    Category :{' '}
                    <span className="text-warning">
                        {this.props.flaggedInformation &&
                        this.props.flaggedInformation?.flaggedCategory &&
                        this.props.flaggedInformation?.flaggedCategory?.name !== 'Other'
                            ? this.props.flaggedInformation.flaggedCategory?.name
                            : `${this.props.flaggedInformation.flaggedCategory?.name} - ${this.props.flaggedInformation?.otherCategoryReason}`}
                    </span>
                </div>
                <div className="bg-white rounded-lg border-black-10">
                    <div className="table-responsive table-scroll">
                        <table className="table w-full table-bordered">
                            <thead className="text-left text-primary border-bottom whitespace-nowrap">
                                <tr>
                                    <th scope="col" className="p-3 font-medium">
                                        Date
                                    </th>
                                    <th scope="col" className="p-3 font-medium">
                                        Reported By
                                    </th>
                                    <th scope="col" className="p-3 font-medium">
                                        Summary
                                    </th>
                                    <th scope="col" className="p-3 font-medium">
                                        Status
                                    </th>
                                </tr>
                            </thead>
                            {this.props.flaggedInformation &&
                            this.props.flaggedInformation.messages &&
                            this.props.flaggedInformation.messages.length ? (
                                <>
                                    {this.props.flaggedInformation.messages.map((data, index) => (
                                        <tbody className="break-word" key={index}>
                                            <tr
                                                key={index}
                                                className="border-bottom whitespace-nowrap"
                                            >
                                                <td className="p-3">
                                                    {moment(data.createdAt).format(
                                                        'MMM DD, YYYY hh:mm A'
                                                    )}
                                                </td>
                                                <td
                                                    className="p-3 table-ellipse"
                                                    title={data.createdBy}
                                                >
                                                    {data.createdBy}
                                                </td>
                                                <td
                                                    className="p-3"
                                                    style={{ whiteSpace: 'normal' }}
                                                >
                                                    {data.message}
                                                </td>
                                                <td className="flex items-center p-3">
                                                    {this.renderStatus(
                                                        data,
                                                        index,
                                                        this.props.flaggedInformation.messages
                                                            .length
                                                    )}
                                                </td>
                                            </tr>
                                        </tbody>
                                    ))}
                                </>
                            ) : (
                                <tr className="border-bottom whitespace-nowrap">
                                    <td colSpan="4" className="p-3 text-center tex-white">
                                        <div>
                                            <p>No data Found</p>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </table>
                    </div>
                </div>
                {this.props.isFromEducator ? (
                    <FlaggingCategorySession
                        {...this.state}
                        openModal={this.state.openFlagInfo}
                        closeModal={() => this.setState({ openFlagInfo: false })}
                        submitFlagSession={() => {
                            this.flagSubmitBtn();
                        }}
                        onChange={(event, name) => {
                            this.onChangeFlagSession(event, name);
                        }}
                    />
                ) : (
                    <FlaggingStatusSession
                        {...this.state}
                        openModal={this.state.openFlagInfo}
                        closeModal={() => this.setState({ openFlagInfo: false })}
                        submitFlagSession={() => {
                            this.flagStatusBtn();
                        }}
                        onChange={(event, name) => {
                            this.onChangeFlagSession(event, name);
                        }}
                    />
                )}
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        flagSessionCategory: (callback) => {
            dispatch(flagSessionCategory(callback));
        },
        flagStatusListing: (visitId, callback) => {
            dispatch(flagStatusListing(visitId, callback));
        },
        submitFlagSession: (values, callback) => {
            dispatch(submitFlagSession(values, callback));
        },
        showNotification: (message, type) => {
            dispatch(showNotification(message, type));
        },
    };
};

export default connect(null, mapDispatchToProps)(FlaggedSessionTable);
